import type { GridColDef } from '@mui/x-data-grid-premium';
import type { LexicalEditor } from 'lexical';
import type { Dispatch, SetStateAction } from 'react';
import { Attachment } from 'sr-types/lib/production/v1/graphql';
import type { Attribute } from '../../attributes/attributes';
import { failedToastMessage, failedToastMessageWithPrefix, successToastMessage } from '../../common/utils/commonUtils';
import type { ProductionStateType } from '../bulkSaveProduction.types';
import { rowsToProduction } from '../bulkSaveProductionUtils';


export const doSave = (
    setIsSaving: Dispatch<SetStateAction<boolean>>,
    rows: any[],
    isAltColDef: boolean,
    altColDefs: any,
    colDefs: any,
    defaultColumns: GridColDef[],
    setErrors: Dispatch<SetStateAction<any>>,
    onClose: () => void,
    onSave: () => void,
    bulkSave: any,
    activeOrganizationAccount: string,
    setShowImportDetails: any,
    setShowImportDetailsDialog: any,
    state?: ProductionStateType,
    attachmentData?: Map<string, Attachment[]>,
    attachmentReferenceEditor?: LexicalEditor,
    isManagedProd?: boolean,
    defaultOwnerOrgId?: string,
    fieldDefinitionReferences?: Attribute[],
) => {
    setIsSaving(true);

    const newProductions = rowsToProduction(
        rows,
        colDefs,
        isManagedProd,
        defaultOwnerOrgId,
        fieldDefinitionReferences,
        state,
        attachmentData,
        attachmentReferenceEditor
    );
    bulkSave({
        variables: {
            input: {
                records: newProductions,
                saveLogFile: true
            }
        },
        context: {
            headers: {
                ownerId: activeOrganizationAccount
            }
        }
    })
        .then((res) => {
            let hasErrors = false;
            const newErrors = {};
            res.data.bulkSaveProduction.results.forEach((r, index) => {
                if (r?.errors) {
                    if (!newErrors[index]) {
                        newErrors[index] = {};
                    }
                    newErrors[index] = r.errors;
                    hasErrors = true;
                    r.errors.forEach((error, index) => {
                        failedToastMessageWithPrefix(`Row ${index + 1}:`, error.field || error.message);
                    });
                }
            });
            if (!hasErrors) {
                successToastMessage('product.import.bulksave.file.process.success', {
                    createdCount: res.data.bulkSaveProduction.createdCount || res.data.bulkSaveProduction.updatedCount
                });
                setShowImportDetails({
                    createdCount: res.data.bulkSaveProduction.createdCount,
                    updatedCount: res.data.bulkSaveProduction.updatedCount,
                    unprocessedCount: res.data.bulkSaveProduction.unprocessedCount,
                    logFile: res.data.bulkSaveProduction.logFile
                });
                setShowImportDetailsDialog(true);
                onClose();
                onSave();
            }
        })
        .catch((error) => {
            failedToastMessage(error?.message || 'product.import.bulksave.file.process.error');
        })
        .finally(() => {
            setIsSaving(false);
        });
};
